// extracted by mini-css-extract-plugin
export default {"container":"as-seen-on-module--container--FMjhY","logosContainer":"as-seen-on-module--logos-container--7YVDx","logo":"as-seen-on-module--logo--17BqY"};